/**
 * Normalizes admin add/edit user payloads before API calls (SRP: field cleanup only).
 * Mutates the provided object in place to match existing page behavior.
 *
 * @param {Record<string, unknown>} userData
 * @param {'delete' | 'null'} locationEmptyStrategy — register (add) deletes empty loc keys; update (edit) sends null
 */
export function cleanAdminUserFormFields(userData, locationEmptyStrategy = 'delete') {
  const marksTypeFields = ['tenthMarksType', 'twelfthMarksType', 'btechMarksType', 'percentageType'];
  const marksValueFields = ['tenthMarks', 'twelfthMarks', 'btechMarks', 'percentage'];
  const locationFields = ['countryId', 'stateId', 'cityId'];
  const preserveFields = ['guardianEmail', ...marksTypeFields];

  Object.keys(userData).forEach((key) => {
    if (marksTypeFields.includes(key)) {
      if (!userData[key] || userData[key] === '') {
        userData[key] = 'Percentage';
      }
    } else if (marksValueFields.includes(key)) {
      if (userData[key] !== null && userData[key] !== undefined && userData[key] !== '') {
        const numValue = parseFloat(userData[key]);
        if (!isNaN(numValue) && numValue >= 0) {
          userData[key] = numValue;
        } else {
          delete userData[key];
        }
      } else {
        delete userData[key];
      }
    } else if (locationFields.includes(key)) {
      if (userData[key] === '' || userData[key] === null || userData[key] === undefined) {
        if (locationEmptyStrategy === 'null') {
          userData[key] = null;
        } else {
          delete userData[key];
        }
      } else {
        userData[key] = String(userData[key]);
      }
    } else if (preserveFields.includes(key)) {
      // keep
    } else if (userData[key] === '' || userData[key] === null || userData[key] === undefined) {
      delete userData[key];
    }
  });
}
